import { createAction } from '@reduxjs/toolkit';

const setStep = createAction('resources/setStep');

export { setStep };
